import { render, staticRenderFns } from "./BatchClientsView.vue?vue&type=template&id=3af250a7&scoped=true"
import script from "./BatchClientsView.vue?vue&type=script&lang=js"
export * from "./BatchClientsView.vue?vue&type=script&lang=js"
import style0 from "./BatchClientsView.vue?vue&type=style&index=0&id=3af250a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af250a7",
  null
  
)

export default component.exports